export default {
  routes: [
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录", // title: "上海致善阔贤科技",
      },
      component: () => import("@/view/Login"),
    },
    {
      path: "/index",
      name: "MinIndex",
      meta: {
        title: "微信通知服务",
      },
      component: () => import("@/view/MinIndex"),
    },
    {
      path: "/addGzh",
      name: "addGzh",
      meta: {
        title: "关注公众号",
      },
      component: () => import("@/view/addGzh"),
    },
    {
      path: "/plusPay",
      name: "PlusPay",
      meta: {
        title: "会员卡系统PLUS续费",
      },
      component: () => import("@/view/wxLink/plus"),
    },
    {
      path: "/prize",
      name: "Prize",
      meta: {
        title: "抽奖",
      },
      component: () => import("@/view/prize/index"),
    },
    {
      path: "/prizeRule",
      name: "PrizeRule",
      meta: {
        title: "活动规则",
      },
      component: () => import("@/view/prize/prizeRule"),
    },
    {
      path: "/customer",
      name: "Customer",
      meta: {
        title: "联系客服",
      },
      component: () => import("@/view/customer/index"),
    },
    {
      path: "*",
      name: "Customer",
      component: () => import("@/view/customer/index"),
    },
  ],
  mode: "hash",
  // mode: "history"
};